export default __webpack_public_path__ + "static/media/ic_multiple.880977dd.svg";